import { Component, OnInit, ViewChild } from '@angular/core'
import { NgForm } from '@angular/forms'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { FormBuilder, FormControl, FormGroup } from '@angular/forms'

import { MessageService } from '../../../../services/message.service'
import { TranslateService } from '@ngx-translate/core'
import { CustomerRequestsService } from '../../../../services/customer-requests.service'

import { ErrorMessageModalComponent } from '../../../modals/error-message-modal/error-message-modal.component'
import { ChangeRequestStatusResult } from 'src/app/models/changeRequestStatusResult'
import { CustomerChangeRequestTypes } from '../../../../enumeration'

@Component({
    selector: 'app-request-status-detail',
    templateUrl: './request-status-detail.component.html',
    styleUrls: ['./request-status-detail.component.scss'],
    standalone: false
})
export class RequestStatusDetailComponent implements OnInit 
{
	@ViewChild('customForm') public customForm: NgForm
	formSubmitted: boolean = false
	
	emailPattern = "^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,4}$"
	request =
	{
		referenceNumber: '',
		emailAddress: '',
	}
	changeRequestStatusResult = new ChangeRequestStatusResult()
	customerChangeRequestFound: boolean = true
	customerChangeRequestType: string = ''

	constructor(
		public dialog: MatDialog,
		private messageService: MessageService,
		private translateService: TranslateService,
		private customerRequestsService: CustomerRequestsService
	) 
	{ 
	}

	ngOnInit() 
	{

	}

	submitForm(customerForm: NgForm)
	{
		this.formSubmitted = true

		if (customerForm.invalid)
		{
			return
		}

		this.messageService.startedHttpRequest('submitForm')
		this.customerRequestsService
		.getChangeRequestState(this.request)
			.subscribe({
				next: (apiResponse) =>
				{
					this.changeRequestStatusResult = apiResponse

					if (this.changeRequestStatusResult != undefined)
					{
						this.customerChangeRequestFound = this.changeRequestStatusResult.customerChangeRequestFound

						switch (this.changeRequestStatusResult.customerChangeRequestTypeId)
						{
							case CustomerChangeRequestTypes.AddressChange:
								this.customerChangeRequestType = this.translateService.instant('REQUEST_ADDRESS_CHANGE_HEADING')
								break
							case CustomerChangeRequestTypes.BankAccountChange:
								this.customerChangeRequestType = this.translateService.instant('REQUEST_BANK_ACCOUNT_CHANGE_HEADING')
								break
							case CustomerChangeRequestTypes.EmailChange:
								this.customerChangeRequestType = this.translateService.instant('REQUEST_EMAIL_CHANGE_HEADING')
								break
							case CustomerChangeRequestTypes.LeaseTransfer:
								this.customerChangeRequestType = this.translateService.instant('REQUEST_LEASE_TRANSFER_HEADING')
								break
							case CustomerChangeRequestTypes.NameChange:       
								this.customerChangeRequestType = this.translateService.instant('REQUEST_NAME_CHANGE_HEADING')
								break
							case CustomerChangeRequestTypes.OtherRequest:       
								this.customerChangeRequestType = this.translateService.instant('REQUEST_OTHER_CHANGE_HEADING')
								break
							case CustomerChangeRequestTypes.PaymentDateChange:       
								this.customerChangeRequestType = this.translateService.instant('REQUEST_PAYMENT_DUE_DATE_CHANGE_HEADING')
								break
							case CustomerChangeRequestTypes.PhoneChange:       
								this.customerChangeRequestType = this.translateService.instant('REQUEST_PHONE_CHANGE_HEADING')
								break							
						}
					}
					else
					{
						this.customerChangeRequestFound = false
					}
												
					this.formSubmitted = false
				},
				error: (error) =>
				{
					this.messageService.completedHttpRequest('submitForm')

					const dialogConfig = new MatDialogConfig()
					dialogConfig.width = '500px',
					dialogConfig.data = {
						title: this.translateService.instant('COMMON_LBL_ERROR'),
						message: this.translateService.instant('COMMON_LBL_ERROR_MSG')
					}		
					this.dialog.open(ErrorMessageModalComponent, dialogConfig)
				},
				complete: () =>
				{
					this.messageService.completedHttpRequest('submitForm')
				}
			})
	}
}
